import React from 'react';

import { Label, Line, Mark } from './LifetimeBadge.styles';

/**
 * "∞ Player engagement suite included": the pricing page's free-plan badge, as its own text-only
 * billing line right under the setup fee. Shown when the order carries no feature charge, so the
 * owner sees that every engagement tool comes free with the setup.
 */
export const LifetimeBadge = (): React.ReactElement => (
  <Line>
    <Mark viewBox="0 0 24 12" aria-hidden>
      <path
        d="M6 2a4 4 0 1 0 0 8c2.5 0 4-2.2 6-4s3.5-4 6-4a4 4 0 1 1 0 8c-2.5 0-4-2.2-6-4S8.5 2 6 2z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
      />
    </Mark>
    <Label text="Player engagement suite included" tag="span" />
  </Line>
);

export default LifetimeBadge;
